/* eslint-disable */
import { gsap, TweenMax, Power2, TimelineMax } from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import "./touchwipe";
import 'jquery-touchswipe'

gsap.config( {
	nullTargetWarn: false,
} );

gsap.registerPlugin( ScrollToPlugin );

const journeyPageAnimations = () => {
	//References to DOM elements
	const $window          = $( window );
	const $document        = $( document );
	const $firstLink       = $( ".first-link" );
	//Only links that starts with #
	const $navButtons      = $( "a.link-title" );
	const $navGoPrev       = $( ".go-prev" );
	const $navGoNext       = $( ".go-next" );
	const $navGoNextStart  = $( "#start-link" );
	const $slidesContainer = $( "#pinContainer" );
	const $slides          = $( ".panel" );
	let $currentSlide      = $slides.first();

	//Animating flag - is our app animating
	let isAnimating = false;

	//The height of the window
	let pageHeight = $window.innerHeight();

	//Key codes for up and down arrows on keyboard. We'll be using this to navigate change slides using the keyboard
	const keyCodes = {
		UP:   38,
		DOWN: 40,
	};

	//First Slide
	goToSlide( $currentSlide );
	// $window.on("resize", resizeTest).resize();
	$window.on( "resize", onResize ).resize();
	$window.on( "mousewheel DOMMouseScroll", onMouseWheel );
	$document.on( "keydown", onKeyDown );
	$navButtons.on( "click", onNavButtonClick );
	$navGoPrev.on( "click", e => {
		e.preventDefault();
		goToPrevSlide();
	} );
	$navGoNext.on( "click", e => {
		e.preventDefault();
		goToNextSlide();
	} );
	$navGoNextStart.on( "click", e => {
		e.preventDefault();
		goToNextSlide();
	} );
	$firstLink.on( "click", e => {
		e.preventDefault();
		goToNextSlide();
	} );

	$document.touchwipe( {
		wipeUp:     function () {
			if ( $window.width() > 767 ) {
				goToPrevSlide();
			}
		},
		wipeDown:   function () {
			if ( $window.width() > 767 ) {
				goToNextSlide();
			}
		},
		min_move_x: 50,
		min_move_y: 15,
	} );

	// When a button is clicked - first get the button href, and then slide to the container, if there's such a container
	function onNavButtonClick( e ) {
		//The clicked button
		let $button = $( this );

		//The slide the button points to
		let $slide = $( $button.attr( "href" ) );

		//If the slide exists, we go to it
		if ( $slide.length ) {
			goToSlide( $slide );
			e.preventDefault();
		}
	}

	/*
			  *   Getting the pressed key. Only if it's up or down arrow, we go to prev or next slide and prevent default behaviour
			  *   This way, if there's text input, the user is still able to fill it
			  * */
	function onKeyDown( e ) {
		const PRESSED_KEY = e.keyCode;

		if ( PRESSED_KEY === keyCodes.UP ) {
			goToPrevSlide();

			e.preventDefault();
		} else if ( PRESSED_KEY === keyCodes.DOWN ) {
			goToNextSlide();

			e.preventDefault();
		}
	}

	// When user scrolls with the mouse, we have to change slides

	function onMouseWheel( e ) {
		// Normalize event wheel delta
		const delta = e.originalEvent.wheelDelta || -e.originalEvent.detail;

		// If the user scrolled up, it goes to previous slide, otherwise - to next slide
		if ( delta < -1 ) {
			if ( $window.width() > 767 ) {
				goToNextSlide();
			}
		} else if ( delta > 1 ) {
			if ( $window.width() > 767 ) {
				goToPrevSlide();
			}
		}
	}

	// If there's a previous slide, slide to it

	function goToPrevSlide() {
		if ( $currentSlide.prev().length ) {
			goToSlide( $currentSlide.prev() );
		}
	}

	// If there's a next slide, slide to it

	function goToNextSlide() {
		if ( $currentSlide.next().length ) {
			goToSlide( $currentSlide.next() );
		}
	}

	/*
			  *   Actual transition between slides
			  * */
	function goToSlide( $slide ) {
		const openPopup = $( ".panel-popup" ).hasClass( "open" ),
			  openMenu  = $( ".header__menu" ).hasClass( "active" );

		//If the slides are not changing and there's such a slide

		if ( isAnimating || openPopup || openMenu || !$slide.length ) {
			return;
		}

		const stickyMapPanel = $( "#panel-2" );

		//setting animating flag to true
		isAnimating      = true;
		$currentSlide    = $slide;
		let currentIndex = $currentSlide.index();
		//Sliding to current slide
		TweenMax.to( $slidesContainer, 1.5, {
			scrollTo:   {
				ease: Power2.easeOut,
				y:
					  currentIndex === 6
					  ? pageHeight * (currentIndex - 1) + 352
					  : pageHeight * currentIndex,
			},
			onStart:    () => {
				const windowWidthGeorgia    = $window.width(),
					  windowHeightGeorgia   = $window.height();
				let coordsArrayGeorgia      = [],
					xGeorgia                = document.getElementById( "georgia" ).coords;
				coordsArrayGeorgia          = xGeorgia.split( "," );
				let scaleXGeorgia           =
						windowWidthGeorgia /
						(coordsArrayGeorgia[ 2 ] - coordsArrayGeorgia[ 0 ]),
					scaleYGeorgia           =
						windowHeightGeorgia /
						(coordsArrayGeorgia[ 3 ] - coordsArrayGeorgia[ 1 ]),
					widthAfterScaleGeorgia  = windowWidthGeorgia * scaleXGeorgia,
					heightAfterScaleGeorgia = windowHeightGeorgia * scaleYGeorgia,
					coordXZeroGeorgia       =
						(widthAfterScaleGeorgia - windowWidthGeorgia) / 2,
					coordYZeroGeorgia       =
						(heightAfterScaleGeorgia - windowHeightGeorgia) / 2,
					xCoordGeorgia           =
						coordXZeroGeorgia - coordsArrayGeorgia[ 0 ] * scaleXGeorgia,
					yCoordGeorgia           =
						coordYZeroGeorgia - coordsArrayGeorgia[ 1 ] * scaleXGeorgia,
					tl1                     = new TimelineMax();
				let windowWidthMisip        = $window.width(),
					windowHeightMisip       = $window.height(),
					coordsArrayMisip        = [],
					xMisip                  = document.getElementById( "missip" ).coords;
				coordsArrayMisip            = xMisip.split( "," );
				let scaleXMisip             =
						windowWidthMisip / (coordsArrayMisip[ 2 ] - coordsArrayMisip[ 0 ]),
					scaleYMisip             =
						windowHeightMisip / (coordsArrayMisip[ 3 ] - coordsArrayMisip[ 1 ]),
					widthAfterScaleMisip    = windowWidthMisip * scaleXMisip,
					heightAfterScaleMisip   = windowHeightMisip * scaleYMisip,
					coordXZeroMisip         = (widthAfterScaleMisip - windowWidthMisip) / 2,
					coordYZeroMisip         = (heightAfterScaleMisip - windowHeightMisip) / 2,
					xCoordMisip             = coordXZeroMisip - coordsArrayMisip[ 0 ] * scaleXMisip,
					yCoordMisip             = coordYZeroMisip - coordsArrayMisip[ 1 ] * scaleXMisip,
					tl2                     = new TimelineMax();

				let windowWidthUtah            = $window.width(),
					windowHeightUtah           = $window.height(),
					coordsArrayUtah            = [],
					xUtah                      = document.getElementById( "utah" ).coords;
				coordsArrayUtah                = xUtah.split( "," );
				let scaleXUtah                 =
						windowWidthUtah / (coordsArrayUtah[ 2 ] - coordsArrayUtah[ 0 ]),
					scaleYUtah                 =
						windowHeightUtah / (coordsArrayUtah[ 3 ] - coordsArrayUtah[ 1 ]),
					widthAfterScaleUtah        = windowWidthUtah * scaleXUtah,
					heightAfterScaleUtah       = windowHeightUtah * scaleYUtah,
					coordXZeroUtah             = (widthAfterScaleUtah - windowWidthUtah) / 2,
					coordYZeroUtah             = (heightAfterScaleUtah - windowHeightUtah) / 2,
					xCoordUtah                 = coordXZeroUtah - coordsArrayUtah[ 0 ] * scaleXUtah,
					yCoordUtah                 = coordYZeroUtah - coordsArrayUtah[ 1 ] * scaleXUtah,
					tl3                        = new TimelineMax();
				let windowWidthBernadino       = $window.width(),
					windowHeightBernadino      = $window.height(),
					coordsArrayBernadino       = [],
					xBernadino                 = document.getElementById( "bernardino" ).coords;
				coordsArrayBernadino           = xBernadino.split( "," );
				let scaleXBernadino            =
						windowWidthBernadino /
						(coordsArrayBernadino[ 2 ] - coordsArrayBernadino[ 0 ]),
					scaleYBernadino            =
						windowHeightBernadino /
						(coordsArrayBernadino[ 3 ] - coordsArrayBernadino[ 1 ]),
					widthAfterScaleBernadino   = windowWidthBernadino * scaleXBernadino,
					heightAfterScaleBernadino  = windowHeightBernadino * scaleYBernadino,
					coordXZeroBernadino        =
						(widthAfterScaleBernadino - windowWidthBernadino) / 2,
					coordYZeroBernadino        =
						(heightAfterScaleBernadino - windowHeightBernadino) / 2,
					xCoordBernadino            =
						coordXZeroBernadino - coordsArrayBernadino[ 0 ] * scaleXBernadino,
					yCoordBernadino            =
						coordYZeroBernadino - coordsArrayBernadino[ 1 ] * scaleXBernadino,
					tl4                        = new TimelineMax();
				let windowWidthLosAngeles      = $window.width(),
					windowHeightLosAngeles     = $window.height(),
					coordsArrayLosAngeles      = [],
					xLosAngeles                = document.getElementById( "los-angeles" ).coords;
				coordsArrayLosAngeles          = xLosAngeles.split( "," );
				let scaleXLosAngeles           =
						windowWidthLosAngeles /
						(coordsArrayLosAngeles[ 2 ] - coordsArrayLosAngeles[ 0 ]),
					scaleYLosAngeles           =
						windowHeightLosAngeles /
						(coordsArrayLosAngeles[ 3 ] - coordsArrayLosAngeles[ 1 ]),
					widthAfterScaleLosAngeles  =
						windowWidthLosAngeles * scaleXLosAngeles,
					heightAfterScaleLosAngeles =
						windowHeightLosAngeles * scaleYLosAngeles,
					coordXZeroLosAngeles       =
						(widthAfterScaleLosAngeles - windowWidthLosAngeles) / 2,
					coordYZeroLosAngeles       =
						(heightAfterScaleLosAngeles - windowHeightLosAngeles) / 2,
					xCoordLosAngeles           =
						coordXZeroLosAngeles -
						coordsArrayLosAngeles[ 0 ] * scaleXLosAngeles,
					yCoordLosAngeles           =
						coordYZeroLosAngeles -
						coordsArrayLosAngeles[ 1 ] * scaleXLosAngeles,
					tl6                        = new TimelineMax();

				switch ( currentIndex ) {
					case 0:
						TweenMax.set( "#img_ID", {
							onComplete: () => {
								TweenMax.to( "#img_ID", 1.3, {
									x:        0,
									y:        0,
									scaleX:   1,
									scaleY:   1,
									filter:   "blur(0)",
									rotation: 0.01,
								} );
								TweenMax.to( ".main-map__after-image--first", 1.3, {
									autoAlpha: 0,
									zIndex:    0,
								} );
							},
						} );

						TweenMax.to( "#start-journey", 1, {
							onComplete: () => {
								TweenMax.to( "#start-journey", 0.3, {
									autoAlpha: 1,
									y:         0,
								} );
							},
						} );

						TweenMax.to( "#case-2", 0.4, {
							onComplete: () => {
								TweenMax.to( "#case-2", 0.5, {
									bottom:    "40vh",
									autoAlpha: 1,
								} );
							},
						} );
						TweenMax.to( "#case-3", 0.6, {
							onComplete: () => {
								TweenMax.to( "#case-3", 0.5, {
									bottom:   "30vh", autoAlpha: 1,
									rotation: 0.01,
								} );
							},
						} );
						TweenMax.to( "#case-4", 0.8, {
							onComplete: () => {
								TweenMax.to( "#case-4", 0.5, {
									bottom:   "20vh", autoAlpha: 1,
									rotation: 0.01,
								} );
							},
						} );
						TweenMax.to( "#case-5", 1, {
							onComplete: () => {
								TweenMax.to( "#case-5", 0.5, {
									bottom:   "10vh", autoAlpha: 1,
									rotation: 0.01
								} );
							},
						} );
						TweenMax.to( "#case-6", 1.2, {
							onComplete: () => {
								TweenMax.to( "#case-6", 0.5, {
									bottom:   "0vh", autoAlpha: 1,
									rotation: 0.01
								} );
							},
						} );
						TweenMax.to( "map-img-bg", 0.3, {
							onComplete: () => {
								TweenMax.to( ".map-img-bg", 0.5, {
									autoAlpha: 0,
								} );
							},
						} );
						$navGoPrev.addClass( "hidden" );
						break;
					case 1:
						$navGoPrev.removeClass( "hidden" );
						stickyMapPanel.addClass( "sticky-map" );
						TweenMax.set( "#img_ID", {
							onComplete: () => {
								tl1
									.to( ".map-img-bg", 0.5, {
										autoAlpha: 0,
										filter:    "blur(1.7px)",
									} )
									.to( "#img_ID", 1.3, {
										x:        xCoordGeorgia,
										y:        yCoordGeorgia,
										scale:    scaleXGeorgia,
										filter:   "blur(1.7px)",
										ease:     Power2.easeInOut,
										rotation: 0.01,
									} )
									.to( ".main-map__after-image--first", 0.5, {
										autoAlpha: 1,
										filter:    "blur(0)",
										zIndex:    2,
										ease:      Power2.easeIn,
									} );
							},
						} );
						TweenMax.to( "#start-journey", 1, {
							autoAlpha: 0,
							y:         -70,
						} );
						TweenMax.set( "#case-2", {
							onComplete: () => {
								TweenMax.to( "#case-2", 1.5, {
									bottom:   "70vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-3", {
							onComplete: () => {
								TweenMax.to( "#case-3", 0.5, {
									bottom:   "30vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-4", {
							onComplete: () => {
								TweenMax.to( "#case-4", 0.5, {
									bottom:   "20vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-5", {
							onComplete: () => {
								TweenMax.to( "#case-5", 0.5, {
									bottom:   "10vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-6", {
							onComplete: () => {
								TweenMax.to( "#case-6", 0.5, {
									bottom:   "0vh",
									rotation: 0.01
								} );
							},
						} );
						break;
					case 2:
						$navGoPrev.removeClass( "hidden" );
						stickyMapPanel.addClass( "sticky-map" );
						TweenMax.set( "#start-journey", {
							autoAlpha: 0,
							y:         30,
							onStart:   () => {
								TweenMax.to( "#start-journey", 0.3, {
									autoAlpha: 0, y: 30,
								} );
							},
						} );
						TweenMax.set( "#case-2", {
							onComplete: () => {
								TweenMax.to( "#case-2", 0.5, {
									bottom:   "70vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-3", {
							onComplete: () => {
								TweenMax.to( "#case-3", 1.5, {
									bottom:   "60vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-4", {
							onComplete: () => {
								TweenMax.to( "#case-4", 0.5, {
									bottom:   "20vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-5", {
							onComplete: () => {
								TweenMax.to( "#case-5", 0.5, {
									bottom:   "10vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-6", {
							onComplete: () => {
								TweenMax.to( "#case-6", 0.5, {
									bottom:   "0vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#img_ID", {
							onComplete: () => {
								tl2
									.to( ".map-img-bg", 0.6, {
										autoAlpha: 0,
										zIndex:    0,
										filter:    "blur(1.7px)",
										ease:      Power2.easeIn,
									} )
									.to( "#img_ID", 1.3, {
										x:        xCoordMisip,
										y:        yCoordMisip,
										scale:    scaleXMisip,
										filter:   "blur(1.7px)",
										ease:     Power2.easeInOut,
										rotation: 0.01,
									} )
									.to( ".main-map__after-image--second", 0.6, {
										autoAlpha: 1,
										zIndex:    1,
										filter:    "blur(0)",
										ease:      Power2.easeIn,
									} );
							},
						} );
						break;
					case 3:
						$navGoPrev.removeClass( "hidden" );
						stickyMapPanel.addClass( "sticky-map" );
						TweenMax.set( "#start-journey", {
							autoAlpha: 0,
							y:         30,
							onStart:   () => {
								TweenMax.to( "#start-journey", 0.3, {
									autoAlpha: 0, y: 30,
								} );
							},
						} );
						TweenMax.set( "#case-2", {
							onComplete: () => {
								TweenMax.to( "#case-2", 0.5, {
									bottom:   "70vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-3", {
							onComplete: () => {
								TweenMax.to( "#case-3", 0.5, {
									bottom:   "60vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-4", {
							onComplete: () => {
								TweenMax.to( "#case-4", 1.5, {
									bottom:   "50vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-5", {
							onComplete: () => {
								TweenMax.to( "#case-5", 0.5, {
									bottom:   "10vh",
									rotation: 0.01
								} );
							},
						} );

						TweenMax.set( "#img_ID", {
							onComplete: () => {
								tl3
									.to( ".map-img-bg", 0.6, {
										autoAlpha: 0,
										zIndex:    0,
										filter:    "blur(1.7px)",
									} )
									.to( "#img_ID", 1.3, {
										x:        xCoordUtah,
										y:        yCoordUtah,
										scale:    scaleXUtah,
										filter:   "blur(1.7px)",
										ease:     Power2.easeInOut,
										rotation: 0.01,
									} )
									.to( ".main-map__after-image--third", 0.6, {
										autoAlpha: 1,
										zIndex:    1,
										filter:    "blur(0)",
										ease:      Power2.easeIn,
									} );
							},
						} );
						break;
					case 4:
						$navGoPrev.removeClass( "hidden" );
						stickyMapPanel.addClass( "sticky-map" );
						TweenMax.set( "#start-journey", {
							autoAlpha: 0,
							y:         30,
							onStart:   () => {
								TweenMax.to( "#start-journey", 0.3, {
									autoAlpha: 0, y: 30,
								} );
							},
						} );
						TweenMax.set( "#case-2", {
							onComplete: () => {
								TweenMax.to( "#case-2", 0.5, {
									bottom:   "70vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-3", {
							onComplete: () => {
								TweenMax.to( "#case-3", 0.5, {
									bottom:   "60vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-4", {
							onComplete: () => {
								TweenMax.to( "#case-4", 0.5, {
									bottom:   "50vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-5", {
							onComplete: () => {
								TweenMax.to( "#case-5", 1.5, {
									bottom:   "40vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-6", {
							onComplete: () => {
								TweenMax.to( "#case-6", 0.5, {
									bottom:   "0vh",
									rotation: 0.01
								} );
							},
						} );

						TweenMax.set( "#img_ID", {
							onComplete: () => {
								tl4
									.to( ".map-img-bg", 0.6, {
										autoAlpha: 0,
										zIndex:    0,
										filter:    "blur(1.7px)",
									} )
									.to( "#img_ID", 1.3, {
										x:        xCoordBernadino,
										y:        yCoordBernadino,
										scale:    scaleXBernadino,
										filter:   "blur(1.7px)",
										ease:     Power2.easeInOut,
										rotation: 0.01,
									} )
									.to( ".main-map__after-image--fourth", 0.8, {
										autoAlpha: 1,
										zIndex:    1,
										filter:    "blur(0)",
										ease:      Power2.easeIn,
									} );
							},
						} );
						break;
					case 5:
						$navGoPrev.removeClass( "hidden" );
						stickyMapPanel.addClass( "sticky-map" );
						TweenMax.set( "#start-journey", {
							autoAlpha: 0,
							y:         30,
							onStart:   () => {
								TweenMax.to( "#start-journey", 0.3, {
									autoAlpha: 0, y: 30,
								} );
							},
						} );
						TweenMax.set( "#case-2", {
							onComplete: () => {
								TweenMax.to( "#case-2", 0.5, {
									bottom:   "70vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-3", {
							onComplete: () => {
								TweenMax.to( "#case-3", 0.5, {
									bottom:   "60vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-4", {
							onComplete: () => {
								TweenMax.to( "#case-4", 0.5, {
									bottom:   "50vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-5", {
							onComplete: () => {
								TweenMax.to( "#case-5", 0.5, {
									bottom:   "40vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#case-6", {
							onComplete: () => {
								TweenMax.to( "#case-6", 1.5, {
									bottom:   "30vh",
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( ".nav-scrolling", {
							onComplete: () => {
								TweenMax.to( ".nav-scrolling", 1.4, {
									y:        0,
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#main-map", {
							onComplete: () => {
								TweenMax.to( "#main-map", 1.499, {
									y:        0,
									rotation: 0.01
								} );
							},
						} );
						$( "#panel-7" ).removeClass( "wrapper" );

						TweenMax.set( "#img_ID", {
							onComplete: () => {
								tl6
									.to( ".map-img-bg", 0.6, {
										autoAlpha: 0,
										zIndex:    0,
										filter:    "blur(1.7px)",
									} )
									.to( "#img_ID", 1.3, {
										x:        xCoordLosAngeles,
										y:        yCoordLosAngeles,
										scale:    scaleXLosAngeles,
										filter:   "blur(1.7px)",
										rotation: 0.01,
										ease:     Power2.easeInOut,
									} )
									.to( ".main-map__after-image--five", 0.6, {
										autoAlpha: 1,
										zIndex:    1,
										filter:    "blur(0)",
										ease:      Power2.easeIn,
									} );
							},
						} );
						break;
					case 6:
						$( "#panel-7" ).addClass( "wrapper" );
						TweenMax.set( ".nav-scrolling", {
							onComplete: () => {
								TweenMax.to( ".nav-scrolling", 1.5, {
									y:        -352,
									rotation: 0.01
								} );
							},
						} );
						TweenMax.set( "#main-map", {
							onComplete: () => {
								TweenMax.to( "#main-map", 1.5, {
									y:        -352,
									rotation: 0.01
								} );
							},
						} );
						let tl7 = new TimelineMax();
						TweenMax.set( "#img_ID", {
							onComplete: () => {
								tl7
									.to( ".map-img-bg", 0.6, {
										autoAlpha: 0,
										zIndex:    0,
										filter:    "blur(1.7px)",
									} )
									.to( "#img_ID", 1.3, {
										x:        0,
										y:        0,
										scaleX:   1,
										scaleY:   1,
										filter:   "blur(0)",
										rotation: 0.01,
									} );
							},
						} );
						break;
				}
			},
			onComplete: onSlideChangeEnd,
		} );

		//Animating menu items
		//Animating menu items
		TweenMax.to( $navButtons.filter( ".active" ), 0.5, {
			className: "-=none",
		} );

		if ( $navButtons.filter( ".active" ).siblings()[ 0 ] ) {
			TweenMax.to( $navButtons.filter( ".active" ).siblings()[ 0 ], 0.5, {
				className: "-=number",
			} );
		}

		let currNavElem = $navButtons.filter(
			"[href=\\#" + $currentSlide.attr( "id" ) + "]"
		);

		TweenMax.to( currNavElem, 0.5, {
			className: "+=active",
		} );

		if ( currNavElem.siblings()[ 0 ] ) {
			TweenMax.to( currNavElem.siblings()[ 0 ], 0.5, {
				className: "+=active number",
			} );
		}
	}

	// Once the sliding is finished, we need to restore "isAnimating" flag.
	// You can also do other things in this function, such as changing page title

	function onSlideChangeEnd() {
		isAnimating = false;
	}

	// When user resize it's browser we need to know the new height, so we can properly align the current slide

	function onResize() {
		//This will give us the new height of the window
		let newPageHeight = $window.innerHeight();

		// If the new height is different from the old height ( the browser is resized vertically ), the slides are resized

		if ( pageHeight !== newPageHeight ) {
			pageHeight = newPageHeight;

			//This can be done via CSS only, but fails into some old browsers, so I prefer to set height via JS
			TweenMax.set( [$slidesContainer, $slides], { height: pageHeight + "px" } );

			//The current slide should be always on the top

			TweenMax.set( $slidesContainer, {
				scrollTo: { y: pageHeight * $currentSlide.index() },
			} );
		}
	}
};

export default journeyPageAnimations;



// WEBPACK FOOTER //
// ./scripts/modules/journeyPageAnimations.js